import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Settings\ProfileController::upload
* @see app/Http/Controllers/Settings/ProfileController.php:62
* @route '/settings/profile/avatar'
*/
export const upload = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(options),
    method: 'post',
})

upload.definition = {
    methods: ["post"],
    url: '/settings/profile/avatar',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Settings\ProfileController::upload
* @see app/Http/Controllers/Settings/ProfileController.php:62
* @route '/settings/profile/avatar'
*/
upload.url = (options?: RouteQueryOptions) => {
    return upload.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\ProfileController::upload
* @see app/Http/Controllers/Settings/ProfileController.php:62
* @route '/settings/profile/avatar'
*/
upload.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\ProfileController::upload
* @see app/Http/Controllers/Settings/ProfileController.php:62
* @route '/settings/profile/avatar'
*/
const uploadForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\ProfileController::upload
* @see app/Http/Controllers/Settings/ProfileController.php:62
* @route '/settings/profile/avatar'
*/
uploadForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(options),
    method: 'post',
})

upload.form = uploadForm

/**
* @see \App\Http\Controllers\Settings\ProfileController::deleteMethod
* @see app/Http/Controllers/Settings/ProfileController.php:105
* @route '/settings/profile/avatar/{mediaId}'
*/
export const deleteMethod = (args: { mediaId: string | number } | [mediaId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/settings/profile/avatar/{mediaId}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Settings\ProfileController::deleteMethod
* @see app/Http/Controllers/Settings/ProfileController.php:105
* @route '/settings/profile/avatar/{mediaId}'
*/
deleteMethod.url = (args: { mediaId: string | number } | [mediaId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { mediaId: args }
    }

    if (Array.isArray(args)) {
        args = {
            mediaId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        mediaId: args.mediaId,
    }

    return deleteMethod.definition.url
            .replace('{mediaId}', parsedArgs.mediaId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\ProfileController::deleteMethod
* @see app/Http/Controllers/Settings/ProfileController.php:105
* @route '/settings/profile/avatar/{mediaId}'
*/
deleteMethod.delete = (args: { mediaId: string | number } | [mediaId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Settings\ProfileController::deleteMethod
* @see app/Http/Controllers/Settings/ProfileController.php:105
* @route '/settings/profile/avatar/{mediaId}'
*/
const deleteMethodForm = (args: { mediaId: string | number } | [mediaId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\ProfileController::deleteMethod
* @see app/Http/Controllers/Settings/ProfileController.php:105
* @route '/settings/profile/avatar/{mediaId}'
*/
deleteMethodForm.delete = (args: { mediaId: string | number } | [mediaId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMethod.form = deleteMethodForm

const avatar = {
    upload: Object.assign(upload, upload),
    delete: Object.assign(deleteMethod, deleteMethod),
}

export default avatar